/** @jsx jsx */
import { jsx } from '@emotion/core';
import Select from 'react-select';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { callApi } from '../../utils';
import { DropdownIndicator } from '../Forms/AdvancedFormSearch/AdvFormSearchSelectItem';
import { saveSearchListStyle, searchSelectStyle } from '../../styles/AdvancedFormSearch/AdvStyleList';

const selectStyles = {
  control: (provided) => ({ ...searchSelectStyle(provided), marginLeft: 0 }),
  menu: () => ({ ...saveSearchListStyle['.menu'], marginLeft: 0 }),
};

export const useTimezones = ({
  loginData, apiFullPath,
}) => {
  const [timezones, setTimezones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiErrMsg, setError] = useState(null);
  useEffect(() => {
    const getTimezones = async () => {
      const { data, isError, errMsg } = await callApi(apiFullPath,
        'GET',
        null,
        loginData
      );

      if (!isError && data.suggestionList) {
        setTimezones(data.suggestionList.map(({ timeZoneNm, label }) => ({ label, value: timeZoneNm })));
      }
      if (isError) {
        setError(errMsg);
      }
      setIsLoading(false);
    };
    getTimezones();
  }, [apiFullPath, loginData]);

  return {
    isLoading,
    timezones,
    apiErrMsg,
  };
};

const TimezoneSelect = React.memo((props) => {
  const {
    value: timeZoneValue, id, loginData, apiFullPath,
  } = props;
  const { timezones, isLoading, apiErrMsg } = useTimezones({
    loginData, apiFullPath,
  });

  const selectedValue = _.find(timezones,
    ({ value }) => value === timeZoneValue);

  const handleOnChange = (e) => {
    props.onChange(e?.value || '');
  };

  return (
    <Select
      isLoading={isLoading}
      components={{ DropdownIndicator, IndicatorSeparator: null }}
      hideSelectedOptions={false}
      isClearable={true}
      onChange={(e) => {
        handleOnChange(e, id);
      }}
      options={timezones}
      placeholder="Select timezone..."
      styles={selectStyles}
      tabSelectsValue={true}
      value={selectedValue}
      noOptionsMessage={() => apiErrMsg}
    />
  );
});

export default TimezoneSelect;
